import type { AnimeWork } from '@/mocks/animeWorks';

interface WorkCardProps {
  work: AnimeWork;
}

export default function WorkCard({ work }: WorkCardProps) {
  return (
    <article className="group flex flex-col rounded-lg bg-background-100/70 p-3 transition-colors hover:bg-background-200/60">
      <div className="relative mb-3 overflow-hidden rounded-md">
        <img
          src={work.cover}
          alt={`${work.title}封面`}
          title={`${work.title} 恋爱后宫漫画`}
          className="aspect-[3/4] w-full object-cover transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute left-2 top-2 rounded-full bg-primary-500 px-2.5 py-1 text-xs font-semibold text-background-50">
          {work.category}
        </span>
        {work.hot && (
          <span className="absolute right-2 top-2 flex h-7 w-7 items-center justify-center rounded-full bg-accent-500 text-xs text-foreground-950">
            <i className="ri-fire-fill" />
          </span>
        )}
        <div className="absolute inset-x-0 bottom-0 flex items-center justify-between bg-gradient-to-t from-foreground-950/70 to-transparent px-2.5 pb-2 pt-8 text-xs text-background-50">
          <span className="flex items-center gap-1">
            <i className="ri-star-fill text-accent-400" />
            {work.rating.toFixed(1)}
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-book-open-line" />
            {work.chapters}话
          </span>
        </div>
      </div>
      <h3 className="mb-2 line-clamp-1 text-base font-semibold text-foreground-950 md:text-lg">
        {work.title}
      </h3>
      <div className="mb-2 flex flex-wrap gap-1.5">
        {work.tags.map((tag) => (
          <span
            key={tag}
            className="rounded-full bg-secondary-100 px-2 py-0.5 text-xs text-secondary-900"
          >
            {tag}
          </span>
        ))}
      </div>
      <p className="mb-3 line-clamp-2 text-sm leading-relaxed text-foreground-600">{work.desc}</p>
      <a
        href="#featured"
        className="mt-auto inline-flex items-center gap-1 text-sm font-semibold text-primary-600 transition-colors hover:text-primary-700"
      >
        查看详情
        <i className="ri-arrow-right-line text-xs transition-transform group-hover:translate-x-0.5" />
      </a>
    </article>
  );
}